/**
 * RintraccioFacile - Calcolo Data Consegna
 * Versione corretta per caricamento file rinominato
 */
/*
const EXCLUDE_WEEKENDS = true;
const ITALIAN_HOLIDAYS = ["01-01", "01-06", "04-25", "05-01", "06-02", "08-15", "11-01", "12-08", "12-25", "12-26"];

let currentProductLeadTimes = { standard: 10, urgente: 7 };

document.addEventListener('DOMContentLoaded', async function() {
  
 async function loadProductData() {
  console.group("%c📦 RintraccioFacile: Debug Deep Scan", "color: #ffffff; background: #222; padding: 4px;");
  
  try {
    const response = await fetch(window.deliveryDataUrl);
    const data = await response.json();

    // Funzione di ricerca avanzata dello SKU
   const findShopifySku = () => {
  // 1. Prova il metodo standard
  const skuElement = document.querySelector('.product__sku, [data-sku], .variant-sku, .sku');
  if (skuElement && skuElement.innerText.trim() !== "") {
    return skuElement.innerText.replace(/SKU:/gi, '').trim();
  }

  // 2. Prova a prenderlo dai dati tecnici di Shopify (più sicuro)
  try {
     // Cerca nel JSON delle varianti che Shopify carica quasi sempre
     const jsonScript = document.querySelector('script[type="application/json"][data-product-json], #ProductJson-product-template');
     if (jsonScript) {
       const productData = JSON.parse(jsonScript.innerHTML);
       return productData.variants[0].sku;
     }
     
     // Alternativa: cerca nell'oggetto globale Shopify
     if (window.meta && window.meta.product && window.meta.product.variants) {
       return window.meta.product.variants[0].sku;
     }
  } catch (e) { console.log("Errore ricerca tecnica SKU"); }

  return null;
};

    let shopifySku = findShopifySku();

    // Se è vuoto, facciamo un loop di 3 tentativi (totale 1.5 secondi)
    if (!shopifySku) {
      for (let i = 1; i <= 3; i++) {
        console.log(`...Tentativo ${i}: SKU non trovato, attendo...`);
        await new Promise(resolve => setTimeout(resolve, 500));
        shopifySku = findShopifySku();
        if (shopifySku) break;
      }
    }

    console.log("%c🔍 RISULTATO SCAN: [" + (shopifySku || "VUOTO") + "]", "color: #ff00ff; font-weight: bold;");

    if (!shopifySku) {
      console.error("❌ Errore: Impossibile trovare lo SKU nel DOM dopo 1.5s. Verifica la classe .product__sku");
      console.groupEnd();
      return;
    }

    // Matching con il JSON
    let productInfo = data.find(p => p.SKU === shopifySku) || data.find(p => p.SKU === shopifySku.split('-')[0]);

    if (productInfo) {
      window.currentProductLeadTimes = {
        standard: parseInt(productInfo.Standard),
        urgente: parseInt(productInfo.Urgente)
      };
      console.log("%c✅ MATCH ESEGUITO!", "color: green; font-weight: bold;");
      console.table(window.currentProductLeadTimes);
      if (typeof updateDeliveryDates === "function") updateDeliveryDates();
    } else {
      console.warn(`❌ Match fallito nel JSON per lo SKU: ${shopifySku}`);
    }

  } catch (e) {
    console.error("❌ Erro error:", e);
  }
  console.groupEnd();
}

  await loadProductData();

  function calculateDeliveryDate(daysToAdd) {
    let date = new Date();
    let addedDays = 0;
    while (addedDays < daysToAdd) {
      date.setDate(date.getDate() + 1);
      const dayOfWeek = date.getDay();
      const monthDay = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      const isWeekend = (dayOfWeek === 0 || dayOfWeek === 6);
      const isHoliday = ITALIAN_HOLIDAYS.includes(monthDay);

      if (EXCLUDE_WEEKENDS) {
        if (!isWeekend && !isHoliday) addedDays++;
      } else {
        if (!isHoliday) addedDays++;
      }
    }
    return date;
  }

  function updateDeliveryDisplay() {
    const shippingOptions = document.querySelectorAll('input[name*="Spedizione"], input[name*="spedizione"]');
    let selectedShipping = "Evasione Standard";
    shippingOptions.forEach(input => { if (input.checked) selectedShipping = input.value; });

    const isUrgent = selectedShipping.toLowerCase().includes('urgente');
    const daysToSum = isUrgent ? currentProductLeadTimes.urgente : currentProductLeadTimes.standard;

    const finalDate = calculateDeliveryDate(daysToSum);
    const formattedUser = finalDate.toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' });

    // Aggiornamento Campi
    const display = document.getElementById('delivery-date-output');
    const hidden = document.getElementById('Input-Custom-DeliveryDate');
    
    if (display) display.textContent = formattedUser;
    if (hidden) hidden.value = formattedUser;
  }

  // Listener cambio variante
  document.addEventListener('change', (e) => {
    if (e.target.name === 'id' || e.target.closest('.product-form')) {
      setTimeout(async () => {
        await loadProductData();
        updateDeliveryDisplay();
      }, 150);
    }
  });

  updateDeliveryDisplay();
});

*/

/**
 * RintraccioFacile - Mapping Properties e Calcolo Data (Versione Merged)
 */
// Tempo di evasione
/**
 * RintraccioFacile - Mapping Properties e Calcolo Data
 * Adattato per varianti: "Tempo di evasione" e "Garanzia Rischio Zero"
 */

// --- CONFIGURAZIONE ---
/*
const DELIVER_PREMIUM_ADD_DAYS = 7;
const DELIVER_STANDARD_ADD_DAYS = 10;
const EXCLUDE_WEEKENDS = true;

const ITALIAN_HOLIDAYS = [
  "01-01", "01-06", "04-25", "05-01", "06-02", "08-15", "11-01", "12-08", "12-25", "12-26"
];

document.addEventListener('DOMContentLoaded', function() {
  // Riferimenti agli elementi UI e Hidden Fields
  const dateOutput = document.getElementById('delivery-date-output');
  const hiddenDate = document.getElementById('Input-Custom-DeliveryDate');
  const hiddenShipping = document.getElementById('Input-Custom-ShippingType');
  const hiddenWarranty = document.getElementById('Input-Custom-Warranty');

  // 1. Funzione di calcolo giorni lavorativi
  function calculateDeliveryDate(daysToAdd) {
    let date = new Date();
    let addedDays = 0;
    while (addedDays < daysToAdd) {
      date.setDate(date.getDate() + 1);
      const dayOfWeek = date.getDay();
      const monthDay = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      const isWeekend = (dayOfWeek === 0 || dayOfWeek === 6);
      const isHoliday = ITALIAN_HOLIDAYS.includes(monthDay);

      if (EXCLUDE_WEEKENDS) {
        if (!isWeekend && !isHoliday) addedDays++;
      } else {
        if (!isHoliday) addedDays++;
      }
    }
    return date;
  }

  // 2. Funzione per aggiornare e PRECOMPILARE gli input
  function updateDeliveryDisplay() {
    // A. Lettura "Tempo di evasione"
    // Cerchiamo l'input radio selezionato che appartiene all'opzione Tempo di evasione
    const shippingOptions = document.querySelectorAll('input[name*="Tempo di evasione"]');
    let selectedShipping = "Evasione Standard";
    shippingOptions.forEach(input => {
      if (input.checked) selectedShipping = input.value;
    });

    // B. Lettura "Garanzia Rischio Zero"
    const warrantyOptions = document.querySelectorAll('input[name*="Garanzia Rischio Zero"]');
    let selectedWarranty = "Senza Garanzia";
    warrantyOptions.forEach(input => {
      if (input.checked) selectedWarranty = input.value;
    });

    // C. Calcolo Data Dinamica basata su "Tempo di evasione"
    const isUrgent = selectedShipping.toLowerCase().includes('urgente');
    const daysToSum = isUrgent ? DELIVER_PREMIUM_ADD_DAYS : DELIVER_STANDARD_ADD_DAYS;
    const finalDate = calculateDeliveryDate(daysToSum);

    const formattedUser = finalDate.toLocaleDateString('it-IT', { 
      day: 'numeric', month: 'long', year: 'numeric' 
    });

    // --- D. PRECOMPILAZIONE ---
    if (dateOutput) dateOutput.textContent = formattedUser;
    if (hiddenDate) hiddenDate.value = formattedUser;
    if (hiddenShipping) hiddenShipping.value = selectedShipping;
    if (hiddenWarranty) hiddenWarranty.value = selectedWarranty;
    
    // Debug Log
    console.log("✅ Sync Dati:", {
      "Tempo Evasione": selectedShipping,
      "Garanzia": selectedWarranty,
      "Data Prevista": formattedUser,
      "dati prodotto" : 1
    });
  }

  // 3. Listeners per il cambio varianti
  // Intercettiamo i cambiamenti nel form del prodotto
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('change', function() {
       setTimeout(updateDeliveryDisplay, 100);
    });
  }

  // Esecuzione immediata al caricamento
  updateDeliveryDisplay();
});

 */


/* LAST FIX */

// --- CONFIGURAZIONE ---

/**
 * RintraccioFacile – Delivery Date (SKU SAFE)
 * Versione definitiva con normalizzazione + mapper robusto
 */


/*
// ================= CONFIG =================
const DELIVER_PREMIUM_ADD_DAYS = 7;    // fallback
const DELIVER_STANDARD_ADD_DAYS = 10;  // fallback
const EXCLUDE_WEEKENDS = true;

const ITALIAN_HOLIDAYS = [
  "01-01", "01-06", "04-25", "05-01", "06-02",
  "08-15", "11-01", "12-08", "12-25", "12-26"
];

// ================= SKU NORMALIZER =================
function normalizeSku(sku) {
  return sku
    .toString()
    .trim()
    .replace(/\u00A0/g, '')     // nbsp
    .replace(/[–—]/g, '-')      // trattini unicode
    .replace(/\s+/g, '')        // spazi
    .toUpperCase();
}

// ================= DELIVERY MAPPER (ARRAY ORIGINALE + MERGE) =================
const DELIVERY_ARRAY = [
  { SKU: "RVE", Standard: 1, Urgente: 1 },
  { SKU: "VIPOC", Standard: 1, Urgente: 1 },
  { SKU: "RVGR", Standard: 3, Urgente: 2 },
  { SKU: "VC", Standard: 1, Urgente: 1 },
  { SKU: "RDI", Standard: 10, Urgente: 7 },
  { SKU: "RDC-1", Standard: 10, Urgente: 7 },
  { SKU: "RDC-2", Standard: 10, Urgente: 7 },
  { SKU: "RALP", Standard: 5, Urgente: 3 },
  { SKU: "RALC", Standard: 5, Urgente: 3 },
  { SKU: "VCP", Standard: 1, Urgente: 1 },
  { SKU: "VCS", Standard: 1, Urgente: 1 },
  { SKU: "VCC", Standard: 1, Urgente: 1 },
  { SKU: "VCSC", Standard: 2, Urgente: 1 },

  // RCPL
  { SKU: "RCPL-1", Standard: 20, Urgente: 15 },

  // IPPEL family
  { SKU: "IPPEL-1", Standard: 20, Urgente: 15 },
  { SKU: "IPPEL-2", Standard: 20, Urgente: 15 },
  { SKU: "IPPEL",   Standard: 20, Urgente: 15 }, // TODO: aggiunta da XLSX (famiglia IPPEL)

  // IPAEL family
  { SKU: "IPAEL-1", Standard: 20, Urgente: 15 },
  { SKU: "IPAEL-2", Standard: 20, Urgente: 15 },
  { SKU: "IPAEL",   Standard: 20, Urgente: 15 }, // TODO: aggiunta da XLSX (famiglia IPAEL)

  { SKU: "VCS-S", Standard: 2, Urgente: 1 },
  { SKU: "VCP-S", Standard: 2, Urgente: 1 },

  { SKU: "RF-RIA", Standard: 15, Urgente: 10 },
  { SKU: "RIP", Standard: 15, Urgente: 10 },
  { SKU: "RASE", Standard: 15, Urgente: 10 },
  { SKU: "RBSA", Standard: 15, Urgente: 10 },

  { SKU: "VISU-CAM-ORD", Standard: 1, Urgente: 1 },
  { SKU: "VISU-CAM-STOR", Standard: 1, Urgente: 1 },
  { SKU: "VISU-ORD", Standard: 1, Urgente: 1 },
  { SKU: "VISU-STOR", Standard: 1, Urgente: 1 },

  { SKU: "BIL-ORD", Standard: 1, Urgente: 1 },
  { SKU: "BIL-STOR", Standard: 1, Urgente: 1 },

  { SKU: "ISPE-IPO-ORD", Standard: 2, Urgente: 1 },
  { SKU: "ISPE-IPO-ACC", Standard: 5, Urgente: 3 },

  { SKU: "COPI-ATTO-ORD", Standard: 5, Urgente: 3 },
  { SKU: "COPI-ATTO-ACC", Standard: 15, Urgente: 10 },

  { SKU: "CERT-DEST-ORD", Standard: 15, Urgente: 10 },
  { SKU: "CERT-DEST-ACC", Standard: 30, Urgente: 20 },

  { SKU: "PROT-ORD", Standard: 5, Urgente: 3 },
  { SKU: "PROT-ACC", Standard: 10, Urgente: 7 },

  { SKU: "VOLT-CATA", Standard: 15, Urgente: 10 },
  { SKU: "SUCC-ORD", Standard: 30, Urgente: 20 },

  { SKU: "REPOR-PERS", Standard: 2, Urgente: 1 },
  { SKU: "REPOR-AZIE", Standard: 2, Urgente: 1 },

  { SKU: "RINTR-ERED", Standard: 15, Urgente: 10 },
  { SKU: "RINTR-CONTI", Standard: 10, Urgente: 7 },

  { SKU: "ESTR-NASC-ORD", Standard: 15, Urgente: 10 },
  { SKU: "CASELL-GIUD-ORD", Standard: 5, Urgente: 3 }
];


// ================= MAP NORMALIZZATA =================
const DELIVERY_MAP = DELIVERY_ARRAY.reduce((acc, item) => {
  const key = normalizeSku(item.SKU);
  acc[key] = {
    standard: Number(item.Standard),
    urgente: Number(item.Urgente)
  };
  return acc;
}, {});

// ================= DOM READY =================
document.addEventListener('DOMContentLoaded', function () {

  console.log("✅ Delivery script inizializzato");

  const dateOutput = document.getElementById('delivery-date-output');
  const hiddenDate = document.getElementById('Input-Custom-DeliveryDate');
  const hiddenShipping = document.getElementById('Input-Custom-ShippingType');
  const hiddenWarranty = document.getElementById('Input-Custom-Warranty');

  // -------- SKU READER (DAL TUO LIQUID) --------
  function getSelectedSKU() {
    const el = document.querySelector('.product__sku');
    if (el && el.innerText.trim() !== "") {
      const sku = el.innerText.replace(/SKU:/gi, '').trim();
      console.log("📦 SKU letta da DOM:", sku);
      return sku;
    }

    if (window.meta?.product?.variants?.length) {
      console.log("📦 SKU letta da window.meta:", window.meta.product.variants[0].sku);
      return window.meta.product.variants[0].sku;
    }

    console.warn("⚠️ SKU non trovata");
    return null;
  }

  // -------- WORKING DAYS CALC --------
  function calculateDeliveryDate(daysToAdd) {
    let date = new Date();
    let addedDays = 0;

    while (addedDays < daysToAdd) {
      date.setDate(date.getDate() + 1);
      const d = date.getDay();
      const md = `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
      const isWeekend = d === 0 || d === 6;
      const isHoliday = ITALIAN_HOLIDAYS.includes(md);

      if (EXCLUDE_WEEKENDS) {
        if (!isWeekend && !isHoliday) addedDays++;
      } else {
        if (!isHoliday) addedDays++;
      }
    }
    return date;
  }

  // -------- MAIN UPDATE --------
  function updateDeliveryDisplay() {

    // Spedizione
    let selectedShipping = "Evasione Standard";
    document.querySelectorAll('input[name*="Tempo di evasione"]').forEach(i => {
      if (i.checked) selectedShipping = i.value;
    });

    // Garanzia
    let selectedWarranty = "Senza Garanzia";
    document.querySelectorAll('input[name*="Garanzia Rischio Zero"]').forEach(i => {
      if (i.checked) selectedWarranty = i.value;
    });

    const isUrgent = selectedShipping.toLowerCase().includes('urgente');

    const rawSku = getSelectedSKU();
    const sku = rawSku ? normalizeSku(rawSku) : null;

    console.log("🧼 SKU normalizzata:", sku);

    let daysToSum = isUrgent ? DELIVER_PREMIUM_ADD_DAYS : DELIVER_STANDARD_ADD_DAYS;
    let source = "FALLBACK";

    // MATCH ESATTO
    if (sku && DELIVERY_MAP[sku]) {
      daysToSum = isUrgent ? DELIVERY_MAP[sku].urgente : DELIVERY_MAP[sku].standard;
      source = "SKU MATCH ESATTO";
    }

    // MATCH BASE (IPPEL)
    else if (sku) {
      const baseSku = sku.split('-')[0];
      const baseKey = Object.keys(DELIVERY_MAP).find(k => k.startsWith(baseSku + "-"));
      if (baseKey) {
        daysToSum = isUrgent ? DELIVERY_MAP[baseKey].urgente : DELIVERY_MAP[baseKey].standard;
        source = `SKU MATCH BASE (${baseSku})`;
      }
    }

    console.log("🧾 Delivery Debug", {
      sku_raw: rawSku,
      sku_normalized: sku,
      shipping: selectedShipping,
      daysToSum,
      source
    });

    const finalDate = calculateDeliveryDate(daysToSum);
    const formattedUser = finalDate.toLocaleDateString('it-IT', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });

    if (dateOutput) dateOutput.textContent = formattedUser;
    if (hiddenDate) hiddenDate.value = formattedUser;
    if (hiddenShipping) hiddenShipping.value = selectedShipping;
    if (hiddenWarranty) hiddenWarranty.value = selectedWarranty;

    console.log("📅 Data consegna calcolata:", formattedUser);
  }

  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    productForm.addEventListener('change', () => {
      console.log("🔄 Cambio form prodotto → ricalcolo delivery");
      setTimeout(updateDeliveryDisplay, 120);
    });
  }

  updateDeliveryDisplay();
});
*/
// ================= CONFIG =================
const DELIVER_PREMIUM_ADD_DAYS = 7;    // fallback urgente
const DELIVER_STANDARD_ADD_DAYS = 10;  // fallback standard
const EXCLUDE_WEEKENDS = true;

const ITALIAN_HOLIDAYS = [
  "01-01", "01-06", "04-25", "05-01", "06-02",
  "08-15", "11-01", "12-08", "12-25", "12-26"
];

// ================= SKU NORMALIZER =================
function normalizeSku(sku) {
  return sku
    .toString()
    .trim()
    .replace(/\u00A0/g, "")
    .replace(/[\u2013\u2014]/g, "-")
    .replace(/\s+/g, "")
    .toUpperCase();
}

// ================= DELIVERY MAP (SKU BASE) =================
// Fonte: Nuova - Mappatura.xlsx
// Safe for production
const DELIVERY_MAP = {
  "AAAM": { standard: 12, urgente: 5 },
  "AAAS": { standard: 12, urgente: 5 },
  "AAE": { standard: 15, urgente: 7 },
  "APFI": { standard: 10, urgente: 7 },
  "ARAF": { standard: 12, urgente: 5 },
  "ARO": { standard: 12, urgente: 5 },

  "IPAEL": { standard: 20, urgente: 15 },
  "IPAEP": { standard: 22, urgente: 17 },
  "IPAL": { standard: 22, urgente: 17 },
  "IPAP": { standard: 22, urgente: 17 },

  "IPPEL": { standard: 20, urgente: 15 },
  "IPPEP": { standard: 22, urgente: 17 },
  "IPPL": { standard: 20, urgente: 15 },
  "IPPP": { standard: 22, urgente: 17 },

  "PPPS": { standard: 10, urgente: 5 },

  "RALL": { standard: 10, urgente: 7 },
  "RALP": { standard: 10, urgente: 7 },
  "RAP": { standard: 15, urgente: 10 },

  "RASE": { standard: 15, urgente: 10 },
  "RBSA": { standard: 15, urgente: 10 },

  "RCAEP": { standard: 22, urgente: 17 },
  "RCAL": { standard: 20, urgente: 15 },
  "RCAP": { standard: 22, urgente: 17 },

  "RCCAEL": { standard: 20, urgente: 15 },

  /** sistituito RCCCDTAPL con  RCCCDTAAL*/
  "RCCCDTAPL": { standard: 20, urgente: 13 }, //Vecchio
  "RCCCDTAAL": { standard: 22, urgente: 17 }, //nuovo
  /** sistituito RCCCDTAPP con  RCCCDTAAP*/
  "RCCCDTAPP": { standard: 22, urgente: 17 }, //Vecchio
  "RCCCDTAAP": { standard: 22, urgente: 17 }, //nuovo

  "RCCPTA": { standard: 20, urgente: 15 },
  /** Aggiunto   RCDTAA */
  "RCDTAA": { standard: 22, urgente: 17 },
  "RCDTAP": { standard: 20, urgente: 13 },

  "RCPEL": { standard: 20, urgente: 15 },
  "RCPEP": { standard: 22, urgente: 17 },
  "RCPL": { standard: 20, urgente: 15 },
  

  "RDAL": { standard: 15, urgente: 10 },
  "RDC": { standard: 15, urgente: 10 },
  "RDI": { standard: 10, urgente: 7 },
  "RDPL": { standard: 10, urgente: 7 },

  "RELP": { standard: 12, urgente: 8 },
  "REL": { standard: 30, urgente: 30 },

  "REP": { standard: 10, urgente: 7 },
  "RCPP": { standard: 22, urgente: 17 },
  "RF-RCAPT": { standard: 20, urgente: 12 },
  "RF-RIA": { standard: 15, urgente: 10 },
  "RF-VPTO": { standard: 15, urgente: 8 },

  "RIP": { standard: 15, urgente: 10 },

  "RNEGG": { standard: 10, urgente: 10 },

  "RPPAL": { standard: 10, urgente: 7 },
  "RPPPA": { standard: 10, urgente: 7 },
  "RPPPL": { standard: 10, urgente: 7 },
  "RPPPP": { standard: 10, urgente: 7 },
  "RPPPS": { standard: 10, urgente: 5 },

  "RVE": { standard: 10, urgente: 7 },
  "RV": { standard: 10, urgente: 7 },
  "RVGA": { standard: 7, urgente: 5 },
  "RVGR": { standard: 7, urgente: 5 },

  "RRPLE": { standard: 20, urgente: 10 },

  "SAL": { standard: 10, urgente: 10 },
  "SRPL": { standard: 12, urgente: 7 },

  "VC": { standard: 1, urgente: 1 },
  "VCS": { standard: 7, urgente: 7 },

  "VIPOC": { standard: 1, urgente: 1 },
  "VIPO": { standard: 10, urgente: 5 },

  // "VSAV": { standard: 0, urgente: 0 }
};

// ================= SKU RESOLVER =================
function resolveSkuKey(skuNorm) {
  if (!skuNorm) return null;

  if (DELIVERY_MAP[skuNorm]) return skuNorm;

  let t = skuNorm;

  // strip suffisso numerico (ABC-1 -> ABC)
  while (/-\d+$/.test(t)) {
    t = t.replace(/-\d+$/, "");
    if (DELIVERY_MAP[t]) return t;
  }

  // fallback progressivo (A-B-C -> A-B -> A)
  while (t.includes("-")) {
    t = t.replace(/-[^-]+$/, "");
    if (DELIVERY_MAP[t]) return t;
  }

  return null;
}

// ================= WORKING DAYS =================
function calculateDeliveryDate(daysToAdd) {
  if (!daysToAdd || Number(daysToAdd) <= 0) return new Date();

  let date = new Date();
  let addedDays = 0;

  while (addedDays < daysToAdd) {
    date.setDate(date.getDate() + 1);

    const d = date.getDay();
    const md = `${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    const isWeekend = d === 0 || d === 6;
    const isHoliday = ITALIAN_HOLIDAYS.includes(md);

    if (EXCLUDE_WEEKENDS) {
      if (!isWeekend && !isHoliday) addedDays++;
    } else {
      if (!isHoliday) addedDays++;
    }
  }

  return date;
}

// ================= DOM READY =================
document.addEventListener("DOMContentLoaded", function () {
  console.log("✅ [MOD] Delivery script inizializzato");

  const dateOutput = document.getElementById("delivery-date-output");
  const hiddenDate = document.getElementById("Input-Custom-DeliveryDate");
  const hiddenShipping = document.getElementById("Input-Custom-ShippingType");
  const hiddenWarranty = document.getElementById("Input-Custom-Warranty");

  // ================= Sync Warrantly Only =================
  // (FIX: qui vede hiddenWarranty)
  function syncWarrantyOnly() {
    let selectedWarranty = "Senza Garanzia";
    document.querySelectorAll('input[name*="Garanzia Rischio Zero"]').forEach(i => {
      if (i.checked) selectedWarranty = i.value;
    });

    if (hiddenWarranty) hiddenWarranty.value = selectedWarranty;
  }

  function getSelectedSKU() {
    const form = document.querySelector('form[action*="/cart/add"]');
    const variantId = form?.querySelector('input[name="id"]')?.value;

    const variants =
      window?.meta?.product?.variants ||
      window?.ShopifyAnalytics?.meta?.product?.variants ||
      [];

    if (variantId && variants.length) {
      const v = variants.find(x => String(x.id) === String(variantId));
      if (v?.sku) return v.sku;
    }

    const el = document.querySelector(".product__sku");
    if (el && el.innerText) {
      return el.innerText.replace(/SKU:/gi, "").trim();
    }

    return null;
  }

  function updateDeliveryDisplay() {

    // ================= LETTURA OPZIONI =================
    let selectedShipping = "Evasione Standard";
    document.querySelectorAll('input[name*="Tempo di evasione"]').forEach(i => {
      if (i.checked) selectedShipping = i.value;
    });

    // Lasciata (come nel tuo) ma NON usata come trigger:
    // il trigger ora è nel listener, quindi non ti cambia più la data quando cambi garanzia.
    let selectedWarranty = "Senza Garanzia";
    document.querySelectorAll('input[name*="Garanzia Rischio Zero"]').forEach(i => {
      if (i.checked) selectedWarranty = i.value;
    });

    const isUrgent = selectedShipping.toLowerCase().includes("urgente");

    // ================= SKU =================
    const rawSku = getSelectedSKU();
    const skuNorm = rawSku ? normalizeSku(rawSku) : null;
    const resolvedKey = resolveSkuKey(skuNorm);

    // ================= GIORNI =================
    let daysToSum = isUrgent ? DELIVER_PREMIUM_ADD_DAYS : DELIVER_STANDARD_ADD_DAYS;

    if (resolvedKey && DELIVERY_MAP[resolvedKey]) {
      daysToSum = isUrgent
        ? DELIVERY_MAP[resolvedKey].urgente
        : DELIVERY_MAP[resolvedKey].standard;
    }

    // ================= DATA =================
    const finalDate = calculateDeliveryDate(daysToSum);
    const formattedUser = finalDate.toLocaleDateString("it-IT", {
      day: "numeric",
      month: "long",
      year: "numeric"
    });

    if (dateOutput) dateOutput.textContent = formattedUser;
    if (hiddenDate) hiddenDate.value = formattedUser;
    if (hiddenShipping) hiddenShipping.value = selectedShipping;
    if (hiddenWarranty) hiddenWarranty.value = selectedWarranty;

    // ================= DEBUG VERIFICA =================
    const productTitle =
      window?.meta?.product?.title ||
      document.querySelector("h1")?.innerText ||
      "Titolo non trovato";

    const standardDays = resolvedKey
      ? DELIVERY_MAP[resolvedKey].standard
      : DELIVER_STANDARD_ADD_DAYS;

    const urgentDays = resolvedKey
      ? DELIVERY_MAP[resolvedKey].urgente
      : DELIVER_PREMIUM_ADD_DAYS;

    console.group("🧪 VERIFICA DELIVERY");
    console.log("📦 Titolo prodotto:", productTitle);
    console.log("🔢 SKU raw:", rawSku);
    console.log("🧼 SKU normalizzato:", skuNorm);
    console.log("🔗 SKU risolto:", resolvedKey || "❌ FALLBACK");
    console.log("📆 Giorni STANDARD:", standardDays);
    console.log("⚡ Giorni URGENTE:", urgentDays);
    console.log("🧠 Fonte:", resolvedKey ? "DELIVERY_MAP" : "FALLBACK");
    console.groupEnd();
  }
  //FIX
    window.updateDeliveryDisplay = updateDeliveryDisplay;
    window.syncWarrantyOnly = syncWarrantyOnly;
  //FIX

  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (productForm) {
    // FIX: ricalcola solo quando serve
    productForm.addEventListener("change", (e) => {
      const t = e.target;

      // Cambio variante (id) o Tempo di evasione -> ricalcolo delivery
      if (t?.name === "id" || (t?.name && t.name.includes("Tempo di evasione"))) {
        setTimeout(updateDeliveryDisplay, 120);
        return;
      }

      // Cambio garanzia -> NON ricalcolare la data, aggiorna solo hidden
      if (t?.name && t.name.includes("Garanzia Rischio Zero")) {
        syncWarrantyOnly();
        return;
      }

      // Tutto il resto -> non fa nulla
    });
  }

  // init
  updateDeliveryDisplay();
  syncWarrantyOnly();
});
